import React from 'react';
import { formatRupiah } from "@/helpers/utils";
import ApiService from '@/services/api';
import Swal from "sweetalert2";
import { _ } from "gridjs-react";
import dayjs from "dayjs";

const getStatusBadge = (status) => {
  const badges = {
    process: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    completed: 'bg-green-100 text-green-800 border-green-300',
    cancelled: 'bg-red-100 text-red-800 border-red-300',
    pending: 'bg-gray-100 text-gray-800 border-gray-300'
  };
  return badges[status] || 'bg-gray-100 text-gray-800 border-gray-300';
};

const getStatusText = (status) => {
  const statusText = {
    process: 'Proses',
    completed: 'Selesai',
    cancelled: 'Dibatalkan',
    pending: 'Menunggu'
  };
  return statusText[status] || status;
};

export const tableColumnsMember = [
  { title: 'Member', queryKey: 'full_name' },
  { 
    title: 'Registration Date', 
    queryKey: 'join_date',
    component: (item) => (
      <span>
        {item.join_date ? new Date(item.join_date).toLocaleDateString() : 'N/A'}
      </span>
    ),
  },
  { title: 'Contact', queryKey: 'phone_number' },
  { title: 'Status', queryKey: 'status' },
];


export const actionHistory = (row, onOpenDetailModal) => {
  const handleCancel = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "Transaction will be cancelled",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, cancel it!'
    });
    
    if (result.isConfirmed) {
      try {
        await ApiService.approvalTransaction(row.id, 'cancel');
        Swal.fire({
          icon: 'success',
          title: 'Cancelled!',
          text: 'Transaction has been cancelled'
        });
        window.location.reload();
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: error.response?.data?.message || 'Failed to cancel transaction'
        });
      }
    }
  };
    

  return _(
    <>
      {(row.status !== "completed" && row.status !== "cancelled") && (
        <div className="flex gap-3">
          <button
            className='rounded-md bg-green-400 hover:bg-green-500 text-white py-1 p-2'
            onClick={() => onOpenDetailModal(row.id)}
            title="Lihat detail dan approve dengan mapping COA"
          >
            <i className='mgc_check_line'></i>
          </button>
          <button
            className='rounded-md bg-red-400 hover:bg-red-500 text-white py-1 p-2'
            onClick={handleCancel}
            title="Cancel transaction"
          >
            <i className='mgc_close_line'></i>
          </button>
        </div>
      )}
    </>
  )
}

export const historyColumns = (onOpenDetailModal) => [
  {
    name: 'Tanggal Transaksi',
    data: (row) => row.transaction_date,
    formatter: (row) => {
      return _(
        <span>
          {dayjs(row.transaction_date).format('DD/MM/YYYY') || 'N/A'}
        </span>
      )
    }
  },
  {
    name: 'Nomor Transaksi',
    data: (row) => row.transaction_number
  },
  {
    name: 'Keterangan',
    data: (row) => row.id,
    formatter: (cell) => {
      return _(
        <span>
          Pembayaran Simpanan Sukarela
        </span>
      )
    }
  },
  {
    name: 'Jumlah',
    data: (row) => formatRupiah(row.amount), 
  },
  {
    name: 'Status',
    data: (row) => row.status,
    formatter: (cell) => {
      const badgeClass = getStatusBadge(cell);
      return _(<span className={`text-gray-900 px-3 py-1 text-sm font-semibold rounded-md border ${getStatusBadge(cell)}`}>{getStatusText(cell)}</span>);
    }
  },
  {
    name: 'Info',
    data: (row) => row,
    formatter: (row) => actionHistory(row, onOpenDetailModal)
  }
]

export const renderActionMember = (row, onClose, navigate) => {
  const handleClick = () => {
    navigate(`/admin/deposit-voluntary-savings?id=${row.id}`);
    onClose();
  };
  return (
    <button
      className='rounded-md bg-green-400 hover:bg-green-500 text-white py-1 p-2'
      onClick={handleClick}
    >
      <i className='mgc_check_line'></i>
    </button>
  )
}
